module.exports = __webpack_public_path__ + "static/img/ZG.7cc3373.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/ZG.png
// module id = t220
// module chunks = 34